import { CrmAuthConfig } from '@touch4it/ng-swp/auth';

import { LoginContentComponent } from '~/shared/components/login/login-content.component';

export const authConfig: CrmAuthConfig = {
  interceptor: {
    interceptHttpCode: [401, 403],
  },
  routeGuard: {
    disabledRoutes: [],
  },
  components: {
    wrapper: {
      layout: 'image',
      logoSrc: '/assets/images/login-logo.png',
      imageSrc: '/assets/images/login-image.png',
      imagePosition: 'left',
    },
    login: {
      messages: { showTitle: false },
      content: {
        content: LoginContentComponent,
      },
    },
    forgottenPassword: {
      backToLoginPlacement: 'wrapper',
      wrapper: {
        logoSrc: '/assets/icons/lock.svg',
      },
    },
    resetPassword: {
      messages: {
        showText: true,
      },
    },
  },
};
